import uniqBy from 'lodash-es/uniqBy';
import {
  fetchKeywords as fetchKeywordsOriginal,
  addComparingGames as addComparingGamesOriginal,
  deleteComparingGames as deleteComparingGamesOriginal,
} from '@/pages/intelligence/services/compare';
import {
  fetchGamesByKeyword as fetchGamesByKeywordOriginal,
  fetchSimilarGames as fetchSimilarGamesOriginal,
} from '@/pages/intelligence/services/mobileCompare';

import type { ICommonActionRes } from '@/pages/intelligence/types/common';

export async function fetchKeywords(keyword: any): Promise<string[]> {
  let res: any;
  let keywords: string[] = [];
  try {
    res = await fetchKeywordsOriginal({
      entity_type: 'mobile',
      keyword,
      system_type: 'pc',
      complement: '1',
    });
    keywords = res?.data?.result;
    keywords = Array.isArray(keywords) ? keywords : [];
  } catch (exception) {
    keywords = [];
  }
  return keywords;
}

export async function fetchGamesByKeyword(keyword: string): Promise<any[]> {
  let games: any[] = [];
  try {
    const res = await fetchGamesByKeywordOriginal({
      entity_type: 'mobile',
      keyword,
      system_type: 'pc',
    });
    const gamesRes = res?.data;
    for (const gameRes of gamesRes) {
      const entityType = gameRes.entity_type;
      const gameId = gameRes?.game_id;
      const gameName = gameRes?.entity_name;
      if (!entityType || !gameId || !gameName) continue;
      games.push({
        ...gameRes,
        entityType,
        gameId,
        gameName,
        cover: gameRes.cover || '',
        publisher: gameRes.publisher || '',
        releaseTime: gameRes.release_time || '',
      });
    }
  } catch (exception) {
    games = [];
  }
  return games;
}

export async function fetchSimilarGames(
  entities: {
    entityType: string;
    gameId: string;
  }[],
): Promise<any[]> {
  const gamesIdsData = entities?.map((entity: any) => entity?.gameId);
  let games: any[] = [];
  try {
    const gamesRes = await fetchSimilarGamesOriginal({
      entity_type: 'mobile',
      game_ids: gamesIdsData || [],
    });
    for (const gameRes of gamesRes) {
      const entityType = gameRes.entity_type;
      const gameId = gameRes?.app_id;
      const gameName = gameRes?.name;
      if (!entityType || !gameId || !gameName) continue;
      games.push({
        ...gameRes,
        entityType,
        gameId,
        gameName,
        cover: gameRes?.cover || '',
        publisher: gameRes.publisher || '',
        releaseTime: gameRes.time || '',
      });
    }
  } catch (exception) {
    games = [];
  }

  return games;
}

// 添加对比游戏
export async function addComparingGames(games: any[]): Promise<ICommonActionRes> {
  let flag: boolean;
  try {
    let gamesTemp: any = games?.map((game, index) => ({
      entity_type: game?.entityType,
      game_id: game?.gameId,
      sequence: index + 1,
    }));
    gamesTemp = Array.isArray(gamesTemp) ? gamesTemp : [];
    gamesTemp = uniqBy(gamesTemp, 'game_id');
    await addComparingGamesOriginal({
      entity_type: 'mobile',
      game_list: gamesTemp,
    });
    flag = true;
  } catch (exception) {
    flag = false;
  }
  return {
    status: flag,
  };
}

// 删除PCConsole对比中的对比游戏（不是删除游戏，目前沿用mobile对比 删除对比游戏的接口）
export async function deleteComparingGames(ids: string[]): Promise<ICommonActionRes> {
  let flag: boolean;
  try {
    const idsTemp = Array.from(new Set(ids));
    await deleteComparingGamesOriginal({ id: idsTemp });
    flag = true;
  } catch (exception) {
    flag = false;
  }
  return {
    status: flag,
  };
}
